import { render, staticRenderFns } from "./index.vue?vue&type=template&id=905c0956&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=905c0956&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905c0956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('905c0956')) {
      api.createRecord('905c0956', component.options)
    } else {
      api.reload('905c0956', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=905c0956&scoped=true", function () {
      api.rerender('905c0956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/freeZone/index.vue"
export default component.exports